const initialState = {
    statusShow: false,
    textAddress:'',
    lng:0,
    lat:0,
};
const modalAddAddress = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_ADD_ADDRESS':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_ADD_ADDRESS':
            return {...state, statusShow: false};
        case 'CHANGE_INPUTS_MODAL_ADDRESS':
            return {...state, [action.name]:action.value};
        case 'CHANGE_LOCATION_MODAL_ADD_ADDRESS':
            return {...state, lng:action.lng,lat:action.lat};
        case 'REFRESH_MODAL_ADD_ADDRESS':
            return initialState;
        default:
            return state;
    }
};

export default modalAddAddress;